import { loadScript,loadCss } from './DOMHelper'

export function loadMoment (callback) {
  if (window.moment) { callback(window.moment) } else { loadScript('https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.25.3/moment.min.js', 'moment', () => { callback(window.moment) }) }
}

export function loadLuxon (callback) {
  if (window.luxon) { callback(window.luxon) } else { loadScript('https://cdnjs.cloudflare.com/ajax/libs/luxon/1.25.0/luxon.min.js', 'luxon', () => { callback(window.luxon) }) }
}

export function loadMomentTimeZone (callback) {
  loadMoment(() => {
    if (window.moment.tz) { callback(window.moment) } else {
      loadScript('https://cdnjs.cloudflare.com/ajax/libs/moment-timezone/0.5.38/moment-timezone.min.js', 'moment-tz', () => {
        loadScript('https://cdnjs.cloudflare.com/ajax/libs/moment-timezone/0.5.38/moment-timezone-with-data.min.js', 'moment-tz-data', () => {
          /**
           * After the scripts are added to the DOM, we check if the 
           * window.moment is defined every 100 ms. As the callback 
           * expects window.moment, we need to wait till it's defined.
           */
          const loaded = setInterval(
            () => {
              if (window.moment) {
                callback(window.moment)
                clearInterval(loaded)
              }
            }, 100)
        })
      })
    }
  })
}

export function loadCropper (callback) {
  if (window.Cropper) { callback(window.Cropper) } else {
    loadScript('https://cdnjs.cloudflare.com/ajax/libs/cropperjs/1.5.9/cropper.min.js', 'cropperjs', () => { callback(window.Cropper) })
    loadCss('https://cdnjs.cloudflare.com/ajax/libs/cropperjs/1.5.9/cropper.min.css')
  }
}
